'use client'

import Link from 'next/link'
import { useAuth } from '@/lib/auth/context'

/**
 * Primeiro item do breadcrumb ("Início"). Quando o usuário está logado, aponta
 * pro Painel (não pra landing) e mostra "Painel" — evita a sensação de deslogar
 * ao navegar de páginas públicas (calculadoras, ferramentas) de volta.
 */
export function CrumbHome({ className }: { className?: string }) {
  const { isSignedIn } = useAuth()
  return (
    <Link href={isSignedIn ? '/dashboard' : '/'} className={className}>
      {isSignedIn ? 'Painel' : 'Início'}
    </Link>
  )
}
